import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SmoothScroll from "./SmoothScroll";
import Cursor from "./Cursor";
import Draft2Nav from "./Draft2Nav";
import Draft2Footer from "./Draft2Footer";

export default function Draft2Layout() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) return; // let anchor links scroll to target
    window.dispatchEvent(new Event("d2-scroll-top"));
    window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);

  return (
    <SmoothScroll>
      <Cursor />
      <div className="bg-[#06170f] min-h-screen">
        <Draft2Nav />
        <main><Outlet /></main>
        <Draft2Footer />
      </div>
    </SmoothScroll>
  );
}
